export enum CleaningStatus {
    Unknown = 0,
    LoadWithoutCleaning = 1,
    CleanAtLoadLocation = 2,
    CleanedOnArrival = 3,
    CleanedAtApprovedEFTCOStation = 4,
    CleanedAtNonApprovedEFTCStation = 5
}